import { useCallback, useEffect, useState } from "react";

const useLocalStorage = (key, defaultValue) => {
    const [value, setValue] = useState(() => {
        const jsonValue = localStorage.getItem(key);
        if (jsonValue != null) {
            return JSON.parse(jsonValue);
        }

        return typeof defaultValue === "function" ? defaultValue() : defaultValue;
    });

    useEffect(() => {
        if (value === undefined) {
            return localStorage.removeItem(key);
        }
        localStorage.setItem(key, JSON.stringify(value));
    }, [value]);

    const remove = useCallback(() => {
        setValue(undefined);
    }, []);

    return [value, setValue, remove];
};

export default useLocalStorage;
